import React, { useEffect } from "react";
import { AppInputDropDown, UBAppModal, UBInput } from "../../../../Libraries";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
const OrderRejectModal = ({ header, body, footer }) => {
  const {
    toggleRejectModal: handleClose,
    rejectReasons: list,
    onChangeText,
    rejectReason,
    toggle,
    title,
    I18n,
  } = body || {};

  const { reason, other } = rejectReason || {};

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (toggle) {
        if (event.key === 'Escape') {
          // Close the modal when the 'Escape' key is pressed
          handleClose()
        } else if (event.key === 'Enter' && footer?.length && !footer[1]?.data?.disabled) {
          footer?.length && footer[1]?.data?.onClick(); // Trigger an action when the 'Enter' key is pressed
        }
      }
    };

    // Add the event listener when the modal is open
    if (toggle) {
      window.addEventListener('keydown', handleKeyDown);
    }

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [toggle, footer]);

  return (
    <UBAppModal
      id="order_reject_modal"
      open={toggle}
      header={{
        handleClose,
        dont_show_cross_icon: true,
        ...header
      }}
      className={styles.OrderRejectModal}
      footer={footer}
    >
      <div className="rejectModalBody">
        <AppInputDropDown
          data={{
            onChangeText: (key, val) => {
              triggerLogEvent(analytics, "sc_order_reject_reason_selected", { reason: val });
              onChangeText(key, val);
            },
            value: reason,
            title,
            list,
          }}
          suffix={{
            name: "dropdownIcon",
            viewBox: "0 0 18 9",
            fill: "#414143",
            width: "18",
            height: "9",
          }}
        />
        {reason == "Other" ? (
          <UBInput
            inputId={"other_id"}
            name="note"
            placeholder={I18n.enter_reason_here}
            onChange={(_, value) => onChangeText(I18n.enter_reason_here, value)}
            value={other}
            multiline
            rows={1}
            maxLength={500}
            baseClassname={styles.noteInput}
          />
        ) : null}
      </div>
    </UBAppModal>
  );
};

export default OrderRejectModal;
